import http from '@/utils/http'

const initialState = () => ({
  source: [],
  destination: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, { system, list }) {
    state[system.toLowerCase()] = list
  }
}

export const getters = {
  source: state => state.source,
  destination: state => state.destination
}

export const actions = {
  fetchEntities ({ commit, rootGetters }, { system, systemCode }) {
    if (!systemCode) {
      return
    }

    return http({
      url: `${process.env.VUE_APP_API_URL}dataconnector/entities/${rootGetters['auth/token']}/${systemCode}`
    }).then(data => {
      commit('SET_LIST', { system, list: data })
    })
  }
}
